import InViewAnimation from '../components/InViewAnimation'
import { LocalizedLink } from '../localization/components/LocalizedLink'
import { useAppT } from '../localization/config'

export default function HomePage() {
  const t = useAppT()

  return (
    <section className="min-h-screen flex items-center justify-center">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="fixed inset-0 w-full h-full object-cover z-[-10] brightness-[0.4]"
      >
        <source src="/assets/videos/intro.mp4" type="video/mp4" />
      </video>
      {/* <img
        src="/assets/images/home.webp"
        alt="Background"
        className="fixed inset-0 w-full h-full object-cover z-[-10] brightness-50"
      /> */}

      <div className="max-w-5xl p-8 pt-20 text-center">
        <InViewAnimation>
          <h1 className="text-light font-medium text-4xl/relaxed sm:text-5xl/relaxed md:text-6xl/relaxed">
            {t.title} ✨
          </h1>
          <h2 className="text-light font-light text-2xl/relaxed sm:text-3xl/relaxed md:text-4xl/relaxed">
            {t.subtitle} ✨
          </h2>
          <div className="h-8"></div>
          <LocalizedLink className="fd-btn fd-btn-primary" to="/contact">
            {t.contact_title}
          </LocalizedLink>
        </InViewAnimation>
      </div>
    </section>
  )
}
